export enum NotificationEntity {
  job = 1,
  chatMessage = 2,
  milestone = 3,
  review = 4,
  resume = 5
}

export enum NotificationType {
  proposalReceived = 1,
  jobInvite = 2,
  messageReceived = 3,
  reviewReceived = 4,
  jobApproved = 5,
  jobBlocked = 6,
  resumeApproved = 7,
  resumeBlocked = 8
}
